export const forMoreInformationText =
  'Para conocer más información sobre el paquete de viaje, haz click en'
export const votesText = 'VOTOS'
